import { CookieService } from 'ngx-cookie-service';
import { Injectable, inject } from '@angular/core';

import { ID } from '@state/base';

import { DISMISSED_COOKIE_NAME } from './client-notifications.model';
import { ClientNotificationsRepository } from './client-notifications.repository';

@Injectable({ providedIn: 'root' })
export class ClientNotificationsService {
  private cookieService = inject(CookieService);
  private repository = inject(ClientNotificationsRepository);

  private domain = this.getCookieDomain();

  dismissNotification(id: ID): void {
    let dismissedIds = this.repository.getDismissedIds();

    if (!dismissedIds.includes(id)) {
      dismissedIds.push(id);
      this.setDismissedIdsCookie(dismissedIds);
      this.repository.setDismissedIds(dismissedIds);
    }
  }

  private setDismissedIdsCookie(ids: ID[]): void {
    this.cookieService.set(DISMISSED_COOKIE_NAME, ids.join(','), {
      domain: this.domain,
      expires: 30,
      path: '/',
      sameSite: 'Strict',
      secure: false
    });
  }

  reset(): void {
    this.repository.reset();
  }

  private getCookieDomain(): string {
    let hostname = window.location.hostname;
    let parts = hostname.split('.');
    // Remove first segment (subdomain like docs, fli, www) if present
    if (parts.length > 2) return parts.slice(1).join('.');
    return hostname;
  }
}
